module.exports = __webpack_public_path__ + "images/store_case_study/licasta-pic2_9c9d1337585dad6ebb5a233f56d78b54.png";